export const SIGN_UP_USER = 'SIGN_UP_USER';
export const SIGN_IN_USER = 'SIGN_IN_USER';
export const SIGN_OUT_USER = 'SIGN_OUT_USER';
export const MENTOR_REQUEST = 'MENTOR_REQUEST';

export const FETCH_MENTORS = 'FETCH_UNAPPROVED_MENTORS';
export const APPROVE_MENTOR = 'APPROVE_MENTOR';
export const BAN_MENTOR = 'BAN_MENTOR';
export const REMOVE_MENTOR = 'REMOVE_MENTOR';
export const RESERVE_MENTOR = 'RESERVE_MENTOR';
export const CANCEL_RESERVE_MENTOR = 'UNRESERVE_MENTOR';
export const FETCH_RESERVATIONS = 'FETCH_RESERVATIONS';
export const TOGGLER = 'TOGGLER';
export const LOADING = 'LOADING';
